module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"angel-train\"-in-long-beach-california-240f738f4bbc49950ac601faf423fcc9.png";